import { AdminAppSettings } from "../../common/types/appSettings";
import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";

export default function adminAppSettingsReducer(
  state: AdminAppSettings = initialState.adminAppSettings,
  action: AnyAction
): AdminAppSettings {
  switch (action.type) {
    case internalActionKeys.SAVE_ADMIN_APP_SETTINGS_SUCCESS:
      return { ...action.adminAppSettings };
    default:
      return state;
  }
}
